import { Component, Input } from '@angular/core';
import { UiCakeCounterBaseComponent } from './ui-cake-counter-base.component';

@Component({
  standalone: false,
  selector: 'ui-multiple-variants-counter',
  templateUrl: './ui-cake-counter.component.html',
  styleUrls: ['./ui-cake-counter.component.scss']
})
export class UiMultipleVariantsCounterComponent extends UiCakeCounterBaseComponent {
  @Input() calcProductCount: (shiftCount: number, isManual?: boolean) => number;

  public shiftCount(isIncrease: boolean) {
    const shift = this._getShift(isIncrease);
    this.count = this.calcProductCount(shift);
    this.onCountUpdated.emit(this.count);
  }

  public inputCounterChanged(count) {
    this.manualInput$.next(+count);
  }

  public updateManualInputCount(count: number) {
    this.count = this.calcProductCount(count, true);
    this.onCountUpdated.emit(this.count);
  }
}
